/** ISO 3166-1 alpha-2 → regional-indicator flag emoji (🇮🇹). */
export const countryFlag = (code: string | null | undefined): string => {
    if (!code || code.length !== 2) return '🌍';
    const upper = code.toUpperCase();
    return String.fromCodePoint(
        ...[...upper].map((char) => 0x1f1e6 - 65 + char.charCodeAt(0)),
    );
};
